import * as React from 'react';
import { get } from 'lodash-es';
import {
  useRef,
  useEffect,
  useState,
  useCallback,
  SyntheticEvent,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DomEvent } from 'leaflet';
import DivControl from '../DivControl';
import { toggleLegend, toggleType } from './legend.store';
import styles from './LegendControl.module.scss';
import cx from 'classnames';

function LegendControl(props: any) {
  const { legends } = props;

  const dispatch = useDispatch();

  const show = useSelector((state) => get(state, ['legend', 'show']));

  const exclude = useSelector((state) => get(state, ['legend', 'exclude']));
  const handleToggleClick = useCallback(
    (event: SyntheticEvent) => {
      event.preventDefault();
      // event.stopPropagation();
      console.log('>>> type 2');
      dispatch(toggleLegend());
      // setShow(!show);
    },
    [dispatch],
  );
  const handleToggleClic2 = useCallback(
    (event: SyntheticEvent) => {
      event.preventDefault();

      event.stopPropagation();
      const type = getAttrFromClosest(event.target, 'data-type');
      console.log('>>> type 1');
      dispatch(toggleType(type));
      return false;
      // setShow(!show);
    },
    [dispatch],
  );
  const handleClickCancel = (event: SyntheticEvent) => {
    event.preventDefault();

    event.stopPropagation();
    console.log('>>>>');
    return false;
  };

  const wrap = useRef<any>();
  useEffect(() => {
    if (wrap.current) {
      DomEvent.disableClickPropagation(wrap.current);
      // DomEvent.on(wrap.current, 'click', DomEvent.stop);
    }
  }, []);
  return (
    <DivControl {...props}>
      <div ref={wrap} className={styles.root} onClick={handleClickCancel}>
        {/* test case here */}
        <ul>
          {show &&
            legends.map((e: string, i: number) => {
              return (
                <li key={i} data-type={e} onClick={handleToggleClic2}>
                  <i
                    className={cx(
                      `icon-${e}`,
                      exclude.indexOf(e) !== -1 && styles.inactive,
                    )}
                  />
                </li>
              );
            })}
          <li key="toggle" className={styles.toggle}>
            <button type="button" onClick={handleToggleClick}>
              <i className="material-icons">
                {`keyboard_arrow_${show ? 'up' : 'down'}`}
              </i>
            </button>
          </li>
        </ul>
        {/* <button onClick={handleClick}>test</button> */}
      </div>
    </DivControl>
  );
}

export default LegendControl;

const getAttrFromClosest = (source: any, attrName: string) => {
  const target = source.getAttribute(attrName)
    ? source
    : source.closest(`[${attrName}]`);
  if (target) {
    return target.getAttribute(attrName);
  }
  return null;
};
